/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Open case related to an asset golden through resolved case_entity IOCs
 * @export
 * @interface RelatedOpenCaseDto
 */
export interface RelatedOpenCaseDto {
    /**
     * 
     * @type {string}
     * @memberof RelatedOpenCaseDto
     */
    caseId?: string;
    /**
     * 
     * @type {string}
     * @memberof RelatedOpenCaseDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof RelatedOpenCaseDto
     */
    severity?: string;
    /**
     * 
     * @type {string}
     * @memberof RelatedOpenCaseDto
     */
    status?: string;
    /**
     * 
     * @type {string}
     * @memberof RelatedOpenCaseDto
     */
    caseEntityType?: string;
    /**
     * 
     * @type {string}
     * @memberof RelatedOpenCaseDto
     */
    caseEntityValue?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof RelatedOpenCaseDto
     */
    linkedEntityTypes?: Array<string>;
}

/**
 * Check if a given object implements the RelatedOpenCaseDto interface.
 */
export function instanceOfRelatedOpenCaseDto(value: object): value is RelatedOpenCaseDto {
    return true;
}

export function RelatedOpenCaseDtoFromJSON(json: any): RelatedOpenCaseDto {
    return RelatedOpenCaseDtoFromJSONTyped(json, false);
}

export function RelatedOpenCaseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): RelatedOpenCaseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'caseId': json['caseId'] == null ? undefined : json['caseId'],
        'name': json['name'] == null ? undefined : json['name'],
        'severity': json['severity'] == null ? undefined : json['severity'],
        'status': json['status'] == null ? undefined : json['status'],
        'caseEntityType': json['caseEntityType'] == null ? undefined : json['caseEntityType'],
        'caseEntityValue': json['caseEntityValue'] == null ? undefined : json['caseEntityValue'],
        'linkedEntityTypes': json['linkedEntityTypes'] == null ? undefined : json['linkedEntityTypes'],
    };
}

export function RelatedOpenCaseDtoToJSON(json: any): RelatedOpenCaseDto {
    return RelatedOpenCaseDtoToJSONTyped(json, false);
}

export function RelatedOpenCaseDtoToJSONTyped(value?: RelatedOpenCaseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'caseId': value['caseId'],
        'name': value['name'],
        'severity': value['severity'],
        'status': value['status'],
        'caseEntityType': value['caseEntityType'],
        'caseEntityValue': value['caseEntityValue'],
        'linkedEntityTypes': value['linkedEntityTypes'],
    };
}

